// extracted by mini-css-extract-plugin
export default {"favorite__content":"styles_favorite__content__LjYG9","favorite__collapseRow":"styles_favorite__collapseRow__VwUAg"};